import { render, staticRenderFns } from "./SendMessageGroupTable.vue?vue&type=template&id=562ef828&scoped=true&lang=pug"
import script from "./SendMessageGroupTable.vue?vue&type=script&lang=ts"
export * from "./SendMessageGroupTable.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageGroupTable.vue?vue&type=style&index=0&id=562ef828&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562ef828",
  null
  
)

export default component.exports